import request from '@/router/axios';

export const getList = (current, size, params) => {
  return request({
    url: '/api/park-epmall/cart/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}


export const getPage = (current, size, params) => {
  return request({
    url: '/api/park-epmall/cart/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}


export const getDetail = (id) => {
  return request({
    url: '/api/park-epmall/cart/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/park-epmall/cart/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/park-epmall/cart/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/park-epmall/cart/submit',
    method: 'post',
    data: row
  })
}

